// src/components/LandscapeWarning.js
import React, { useEffect, useState } from "react";
import rotate from "../assets/images/rotate.png";

const LandscapeWarning = () => {
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!isLandscape) {
    return null; // Don't render anything if in portrait mode
  }

  return (
    <div className="flexx sm:hidden">
      
    
      <div
        className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-100 z-50"
      >
        <img
          src={rotate}
          alt="Please rotate your device"
          className="max-w-xs mb-4"
        />
        <p className="text-indigo-900 text-xl font-semibold">
          Rotate your cellphone
        </p>
      </div>
    </div>
  );
};

export default LandscapeWarning;
